export default "__VITE_ASSET__9fb4dd49__"